import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames';

import { withStyles } from '@material-ui/core/styles';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';

import IconButton from 'components/common/IconButton';
import Menu, { MenuItem } from 'components/common/Menu';
import IconMoreVert from 'components/icons/IconMoreVert';
import HCPCSCodeCreateEditDialog from 'components/settings/HCPCSCodeCreateEditDialog';
import Link from 'components/common/Link';

import splitLongWords from 'utils/splitLongWords';
import formatPrice from 'utils/formatPrice';

const styles = theme => ({
  iconMoreVert: {
    width: 24,
    height: 24,
  },
  buttonCell: {
    textAlign: 'right',
    padding: '0 10px 0 0',
    '&:last-child': {
      padding: '0 10px 0 0',
    },
  },
  cellCode: {
    whiteSpace: 'nowrap',
  },
  cellPrice: {
    whiteSpace: 'nowrap',
  },
  cellDescription: {
    width: '35%',
  },
  cellMedicaid: {
    borderLeft: `1px dashed ${theme.palette.primary[500]}`,
  },
  cellMedicaidLast: {
    borderRight: `1px dashed ${theme.palette.primary[500]}`,
  },
  cellMedicare: {
    borderLeft: `1px dashed ${theme.palette.notification[700]}`,
  },
  cellMedicareLast: {
    borderRight: `1px dashed ${theme.palette.notification[700]}`,
  },
});

class HCPCSCodesTableRow extends Component {
  constructor(props) {
    super(props);

    this.state = {
      anchorEl: null,
      editDialogOpen: false,
    };

    this.onMenuButtonClick = this.onMenuButtonClick.bind(this);
    this.onMenuClose = this.onMenuClose.bind(this);
    this.onEditMenuItemClick = this.onEditMenuItemClick.bind(this);
    this.onEditDialogClose = this.onEditDialogClose.bind(this);
  }

  onMenuButtonClick(event) {
    this.setState({
      anchorEl: event.currentTarget,
    });
  }

  onMenuClose() {
    this.setState({ anchorEl: null });
  }

  onEditMenuItemClick() {
    this.setState({
      anchorEl: null,
      editDialogOpen: true,
    });
  }

  onEditDialogClose() {
    this.setState({ editDialogOpen: false });
  }

  render() {
    const { account, State, classes } = this.props;
    const { anchorEl, editDialogOpen } = this.state;
    const open = Boolean(anchorEl);
    const medicaidPrice = this.props['HCPC S Code Price'].find(item => item['Price Type'] === 'Medicaid'
      && item.State === State);
    const medicarePrice = this.props['HCPC S Code Price'].find(item => item['Price Type'] === 'Medicare'
      && item.State === State);
    return (
      <TableRow>
        <TableCell className={classes.cellCode}>
          <Link
            breakWord
            onClick={this.onEditMenuItemClick}
            disabled={account.Roles.filter(item =>
              item.Name === 'Master Administrator' || item.Name === 'Administrator' || item.Name === 'Manager').length === 0}
          >
            {this.props['HCPC S Code']}
          </Link>
        </TableCell>
        <TableCell>
          {this.props['Default Modifiers']
            ? this.props['Default Modifiers'].join(', ') : ''}
        </TableCell>
        <TableCell className={classNames(classes.cellDescription, classes.cellMedicaid)}>
          {(medicaidPrice && medicaidPrice.Description)
            ? splitLongWords(medicaidPrice.Description) : ''}
        </TableCell>
        <TableCell className={classes.cellPrice}>
          {(medicaidPrice && medicaidPrice['Sale Price'])
            ? formatPrice(medicaidPrice['Sale Price']) : ''}
        </TableCell>
        <TableCell className={classes.cellPrice}>
          {(medicaidPrice && medicaidPrice['Sale Price Rural'])
            ? formatPrice(medicaidPrice['Sale Price Rural']) : ''}
        </TableCell>
        <TableCell className={classes.cellPrice}>
          {(medicaidPrice && medicaidPrice['Rental Price'])
            ? formatPrice(medicaidPrice['Rental Price']) : ''}
        </TableCell>
        <TableCell className={classNames(classes.cellPrice, classes.cellMedicaidLast)}>
          {(medicaidPrice && medicaidPrice['Rental Price Rural'])
            ? formatPrice(medicaidPrice['Rental Price Rural']) : ''}
        </TableCell>
        <TableCell />
        <TableCell className={classNames(classes.cellDescription, classes.cellMedicare)}>
          {medicarePrice && medicarePrice.Description
            && splitLongWords(medicarePrice.Description)}
        </TableCell>
        <TableCell className={classes.cellPrice}>
          {(medicarePrice && medicarePrice['Sale Price'])
            ? formatPrice(medicarePrice['Sale Price']) : ''}
        </TableCell>
        <TableCell className={classes.cellPrice}>
          {(medicarePrice && medicarePrice['Sale Price Rural'])
            ? formatPrice(medicarePrice['Sale Price Rural']) : ''}
        </TableCell>
        <TableCell className={classes.cellPrice}>
          {(medicarePrice && medicarePrice['Rental Price'])
            ? formatPrice(medicarePrice['Rental Price']) : ''}
        </TableCell>
        <TableCell className={classNames(classes.cellPrice, classes.cellMedicareLast)}>
          {(medicarePrice && medicarePrice['Rental Price Rural'])
            ? formatPrice(medicarePrice['Rental Price Rural']) : ''}
        </TableCell>
        <TableCell className={classes.buttonCell}>
          <IconButton
            aria-label="More"
            aria-owns={open ? `${this.props.ID}-hcpcsCode-menu` : null}
            aria-haspopup="true"
            onClick={this.onMenuButtonClick}
            tooltipContent="Open Menu"
          >
            <IconMoreVert className={classes.iconMoreVert} />
          </IconButton>
          <Menu
            id={`${this.props.ID}-hcpcsCode-menu`}
            anchorEl={anchorEl}
            open={open}
            onClose={this.onMenuClose}
            list
            maxHeight={130}
          >
            <MenuItem
              onClick={this.onEditMenuItemClick}
              disabled={account.Roles.filter(item =>
                item.Name === 'Master Administrator' || item.Name === 'Administrator' || item.Name === 'Manager').length === 0}
            >
              Edit
            </MenuItem>
          </Menu>
        </TableCell>
        <HCPCSCodeCreateEditDialog
          form={`hcpcsCodeEdit-${this.props.ID}`}
          open={editDialogOpen}
          ID={this.props.ID}
          initialValues={{
            'HCPC S Code': this.props['HCPC S Code'],
            'Medicaid Price ID': (medicaidPrice && medicaidPrice.ID)
              ? medicaidPrice.ID : '',
            'Medicaid Description': (medicaidPrice && medicaidPrice.Description)
              ? medicaidPrice.Description : '',
            'Medicaid Rental Price': (medicaidPrice && medicaidPrice['Rental Price'])
              ? formatPrice(medicaidPrice['Rental Price']) : '',
            'Medicaid Sale Price': (medicaidPrice && medicaidPrice['Sale Price'])
              ? formatPrice(medicaidPrice['Sale Price']) : '',
            'Medicaid Rental Price Rural': (medicaidPrice && medicaidPrice['Rental Price Rural'])
              ? formatPrice(medicaidPrice['Rental Price Rural']) : '',
            'Medicaid Sale Price Rural': (medicaidPrice && medicaidPrice['Sale Price Rural'])
              ? formatPrice(medicaidPrice['Sale Price Rural']) : '',
            'Medicare Price ID': (medicarePrice && medicarePrice.ID)
              ? medicarePrice.ID : '',
            'Medicare Description': (medicarePrice && medicarePrice.Description)
              ? medicarePrice.Description : '',
            'Medicare Rental Price': medicarePrice && medicarePrice['Rental Price']
              ? formatPrice(medicarePrice['Rental Price']) : '',
            'Medicare Sale Price': medicarePrice && medicarePrice['Sale Price']
              ? formatPrice(medicarePrice['Sale Price']) : '',
            'Medicare Rental Price Rural': medicarePrice && medicarePrice['Rental Price Rural']
              ? formatPrice(medicarePrice['Rental Price Rural']) : '',
            'Medicare Sale Price Rural': medicarePrice && medicarePrice['Sale Price Rural']
              ? formatPrice(medicarePrice['Sale Price Rural']) : '',
            'Default Modifiers': this.props['Default Modifiers'],
            'Do Not Override': this.props['Do Not Override'],
          }}
          State={State}
          onClose={this.onEditDialogClose}
          onSubmitSuccess={this.onEditDialogClose}
        />
      </TableRow>
    );
  }
}

HCPCSCodesTableRow.propTypes = {
  ID: PropTypes.number.isRequired,
  'HCPC S Code': PropTypes.string.isRequired,
  'Default Modifiers': PropTypes.arrayOf(PropTypes.string),
  account: PropTypes.shape({
    Roles: PropTypes.arrayOf(PropTypes.shape({
      Name: PropTypes.string.isRequired,
    })).isRequired,
  }).isRequired,
  State: PropTypes.string.isRequired,
  classes: PropTypes.shape({
    iconMoreVert: PropTypes.string.isRequired,
    buttonCell: PropTypes.string.isRequired,
    cellCode: PropTypes.string.isRequired,
    cellPrice: PropTypes.string.isRequired,
    cellDescription: PropTypes.string.isRequired,
  }).isRequired,
};

HCPCSCodesTableRow.defaultProps = {
  'Default Modifiers': [],
};

const mapStateToProps = store => ({
  account: store.account,
});

export default connect(mapStateToProps)(withStyles(styles)(HCPCSCodesTableRow));



// WEBPACK FOOTER //
// ./src/components/settings/HCPCSCodesTable/HCPCSCodesTableRow.js